import { Text, TextLink, theme } from '@updater/ui-uds';

export const Disclaimer: React.FC = () => {
  return (
    <Text variant="s" pt="s" color={theme.colors.navbarText}>
      By clicking finish and creating an account, your information is 100%
      protected by, and subject to, our{' '}
      <TextLink
        href="https://updater.com/terms"
        target="_blank"
        showTextDecoration
      >
        Privacy Policy.
      </TextLink>
    </Text>
  );
};
